import React from 'react';
import styled from 'styled-components';
import { UiFlex, UiFlexProps } from '@open-stack/ui';

export enum XAlertType {
    DEFAULT = 'DEFAULT',
    SUCCESS = 'SUCCESS',
    WARNING = 'WARNING',
    ERROR = 'ERROR',
}

const Wrapper = styled(UiFlex)`
    background-color: var(--color-layer);
    padding: calc(2 * var(--ui-spacing));
    border-radius: var(--XCard-border-radius);
    border-left: 2px solid transparent;
    position: relative;
    // TODO: HARDCODED
    font-size: 20px;

    &.${XAlertType.DEFAULT} {
        background-color: var(--color-info-opacity);
        border-color: var(--x-color-info);
    }

    &.${XAlertType.SUCCESS} {
        background-color: var(--color-success-opacity);
        border-color: var(--x-color-success);
    }

    &.${XAlertType.WARNING} {
        background-color: var(--color-warning-opacity);
        border-color: var(--x-color-warning);
    }

    &.${XAlertType.ERROR} {
        background-color: var(--color-error-opacity);
        border-color: var(--x-color-error);
    }
`;

export interface XAlertProps extends UiFlexProps {
    type?: XAlertType;
}

export function XAlert({ type, ...rest }: XAlertProps) {
    type = type ?? XAlertType.DEFAULT;

    return <Wrapper className={type} {...rest} />;
}
